/**
 * Внешние адреса профиля (T11.10, `09_UI_UX.md` §4.5).
 *
 * Поддержка, политика обработки персональных данных и оферта живут вне
 * приложения, и адреса у них разные в разработке и в бою. Отсюда
 * переменные сборки, а не строки в разметке.
 *
 * ## Незаполненный адрес показывается, а не прячется
 *
 * Политику и оферту готовит юрист (`13_LEGAL.md` §5), и до беты их
 * может не быть. Спрятать строку значило бы получить сборку, где
 * обязательный по закону документ недостижим и никто этого не видит.
 * Строка остаётся на месте с пометкой «готовится» — её видно и в
 * приложении, и на снимке экрана.
 */

/** Пусто, если переменная не задана при сборке. */
function link(value: string | undefined): string | null {
  const trimmed = (value ?? '').trim();

  return trimmed === '' ? null : trimmed;
}

/** Чат поддержки: `VITE_SUPPORT_URL`, обычно ссылка на Telegram. */
export const SUPPORT_URL = link(import.meta.env['VITE_SUPPORT_URL']);

/** Политика обработки персональных данных: `VITE_POLICY_URL`. */
export const POLICY_URL = link(import.meta.env['VITE_POLICY_URL']);

/** Пользовательское соглашение (оферта): `VITE_OFFER_URL`. */
export const OFFER_URL = link(import.meta.env['VITE_OFFER_URL']);
